import {ReportSection, SectionNumberingScheme} from "../../../report/report_types";

/**
 * See EditReportToolComponent for an example of how to use this function.
 */
export function computeSectionNumberingHelper(sectionNumbers: {[sectionId: string]: string}, parentNumbering: string, depth: number, sections: ReportSection[], documentNumbering: SectionNumberingScheme) {
    let currentIndex = 0;
    sections.forEach((section) => {
        if ((section.numberingOverride?.type || documentNumbering) === 'NoNumbering') {
            sectionNumbers[section.id] = '';
        } else if ((section.numberingOverride?.type || documentNumbering) === 'HierarchicalNumbering') {
            if (section.title || section.subsections.length > 0) {
                // this also means that sections without a title are numbered if they have subsections. Otherwise, is would look strange.
                const newNumbering = parentNumbering ? (parentNumbering + '.' + String(currentIndex + 1)) : String(currentIndex + 1);
                sectionNumbers[section.id] = newNumbering;
                currentIndex++;
                if (section.subsections.length > 0) {
                    computeSectionNumberingHelper(sectionNumbers, newNumbering, depth + 1, section.subsections, documentNumbering);
                }
            }
        } else if ((section.numberingOverride?.type || documentNumbering) === 'SimpleNumbering') {
            sectionNumbers[section.id] = String(currentIndex + 1);
            currentIndex++;
        }
    });
}
